function parseBoolEnv(
  value: string | undefined,
  defaultValue: boolean,
): boolean {
  if (value === undefined || value === "") return defaultValue;
  return value === "true";
}

/**
 * Per-runtime log toggles.
 * NEXT_PUBLIC_SENTRY_ENABLE_CLIENT_LOGS — controls browser (default: true)
 * NEXT_PUBLIC_SENTRY_ENABLE_SERVER_LOGS — controls Node.js / Edge (default: true)
 * Set either to "false" to disable without a code deploy.
 */
export const enableClientLogs = parseBoolEnv(
  process.env.NEXT_PUBLIC_SENTRY_ENABLE_CLIENT_LOGS,
  true,
);
export const enableServerLogs = parseBoolEnv(
  process.env.NEXT_PUBLIC_SENTRY_ENABLE_SERVER_LOGS,
  true,
);
